import React, { useEffect, useState } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { Button, useTheme } from 'react-native-paper';
import { FieldArray } from 'formik';
import PropTypes from 'prop-types';

import CropDataTable from './CropDataTable';

// Find the weather station associated with the selected city
const findWeatherStation = (city) => {
  const colcaCities = ['chivay', 'madrigal', 'cabanaconde'];
  if (city === 'pampaDeMajes') {
    return 'majes';
  } else if (colcaCities.indexOf(city) > 0) {
    return 'colca';
  } else {
    return 'arqpcty';
  }
};

function CropSelection({
  actions,
  appStyles,
  language,
  pageContent,
  toggleDisableNextStep,
}) {
  const { values, errors } = actions;
  const { colors } = useTheme();

  // Nearest weather station to selected city
  const weatherStation = findWeatherStation(values.weatherStation);
  // Crops associated with the station
  const availableCrops = pageContent[weatherStation];
  // Track which crops are checked - initialize all to false
  const [checked, toggleChecked] = useState(
    Array.from({ length: availableCrops.length }, (e) => false)
  );

  // Disable next step until at least 1 crop has been selected
  useEffect(() => {
    toggleDisableNextStep(values.crops.length < 1);

    // If crops exist in the array
    if (values.crops.length > 0) {
      const crops = values.crops.map((crop) => crop.name);
      toggleChecked(availableCrops.map((crop) => crops.includes(crop.key)));
    }
  }, [values]);

  return (
    <View>
      <FieldArray
        name="crops"
        render={(arrayHelpers) => (
          <View style={{ alignItems: 'center', justifyContent: 'center' }}>
            <CropDataTable
              arrayHelpers={arrayHelpers}
              crops={availableCrops}
              checked={checked}
              language={language}
              pageContent={pageContent}
              toggleChecked={toggleChecked}
              values={values}
            />
            {typeof errors.crops === 'string' ? (
              <Text style={styles.error}>{errors.crops}</Text>
            ) : null}
            <Button
              style={appStyles.button}
              labelStyle={appStyles.labelStyle}
              color={colors.primary}
              mode="contained"
              onPress={() => {
                checked.forEach((isChecked, checkIndex) => {
                  // If a crop is not already in the array, add it
                  if (!isChecked) {
                    arrayHelpers.push({
                      name: availableCrops[checkIndex].key,
                    });
                  }
                });
                // Set all crops to checked
                toggleChecked(new Array(checked.length).fill(true));
              }}
            >
              {language === 'en'
                ? 'Select all'
                : language === 'es'
                ? 'Seleccionar todos'
                : 'TRANSLATE'}
            </Button>
          </View>
        )}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  error: {
    color: 'red',
  },
});

CropSelection.propTypes = {
  actions: PropTypes.shape({
    values: PropTypes.object,
    errors: PropTypes.object,
  }),
  language: PropTypes.string,
  pageContent: PropTypes.objectOf(PropTypes.array),
  toggleDisableNextStep: PropTypes.func,
};

export default CropSelection;
